import { render, staticRenderFns } from "./DeviceModelsUpdateBox.vue?vue&type=template&id=f37ca8be"
import script from "./DeviceModelsUpdateBox.vue?vue&type=script&lang=js"
export * from "./DeviceModelsUpdateBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports